/* @flow */
import * as React from 'react';

// Styles
import styles from './ErrorMessage.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

// Components
import ErrorIcon from '@mui/icons-material/Error';

const useStyles = createUseThemeStyles(styles);

type Props = {
  id?: string,
  children: React.Node,
};

/**
 * Must be in a relative container
 * @param {Props} param0 Props
 * @returns {React.Node} Error message
 */
const ErrorMessage = ({ id, children }: Props) => {
  const classes = useStyles();

  return (
    <span className={classes.root} role="alert" id={id}>
      <ErrorIcon /> {children}
    </span>
  );
};

export default React.memo<Props>(ErrorMessage);
